<!-- routify:options param-is-page=true -->
<script lang="ts">
  import DealTiersShowPage from "@retailer/svelte/DealTiers/Show.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";

  const load = async () => {
    await RetailerFulfillmentMethodsStore.refreshFulfillmentMethods();

    const results = await HttpPromise({
      method: "GET",
      url: `/api/retailer/deals/${$params.dealId}`,
    });
    return {
      deal: results,
    };
  };
</script>

{#key $params.dealTierId}
  {#await load()}
    <Spinner />
  {:then data}
    <DealTiersShowPage
      deal={data.deal.deal}
      products={data.deal.products}
      dealTierId={$params.dealTierId}
    />
  {:catch error}
    <div>We had an error loading this deal - please refresh.</div>
  {/await}
{/key}
